import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#ffb423",
        secondary: "#363537",
        accent: "#5d78ff",
        error: "#e15000",
        info: "#5578eb",
        success: "#4c8c73",
        warning: "#ffb423"
      }
    }
  }
});
